export default __webpack_public_path__ + "static/social-background-e0540dff9abbb9ee8de67b71733013b6.svg";